export default "__VITE_ASSET__D0DnK00O__"